<div class="backpage-wrapper">
  <div class="inventory-page-content-creator">
    <div class="inventory-section">
      <div
        class="inventory-container padding s6 all"
        *ifPermissions="['Engage Support', 'Internal Admin']"
      >
        <div class="header">
          <h1 *ifPermissions="['Engage View', 'Engage Transfer']">
            Schlage Mobile Credentials with ENGAGE&trade;
          </h1>
          <h1 *ifPermissions="['Internal Admin', 'Engage Support']">
            Schlage Mobile Credentials with ENGAGE&trade; - Techsupport
          </h1>
        </div>
        <div class="search padding s3 all">
          <div class="inventory-main-title mat-title">
            {{ "Search.SelectCompany" | translate }}:
          </div>

          <form class="example-form" [formGroup]="form">
            <mat-form-field
              class="example-full-width"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label class="selectCo">{{
                "Search.Company" | translate
              }}</mat-label>
              <input
                type="text"
                placeholder="Enter Company Name, Purchase/Sales Order Details, or SiteID"
                matInput
                formControlName="myControl"
                [matAutocomplete]="auto"
                [errorStateMatcher]="errorStateMatcher"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                mat-autoselect="true"
                [displayWith]="displayName.bind(this)"
                (optionSelected)="optionSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option.businessId }} (Account #{{
                    option.accountNumber || "N/A"
                  }}) <br />
                  {{ option.addressCity }}, {{ option.addressState }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="
                  (form.controls['myControl'].dirty ||
                    form.controls['myControl'].touched) &&
                  noResultsFound
                "
                >No results - Try again</mat-error
              >
            </mat-form-field>
          </form>
        </div>
      </div>
      <div
        class="inventory-container padding s6 all"
        *ifPermissions="['Engage View', 'Engage Transfer']"
      >
        <div class="header">
          <h1>Schlage Mobile Credentials with ENGAGE&trade;</h1>
        </div>
        <app-branch-inputs
          *ifPermissions="[
            'Engage View',
            'Engage Transfer',
            'API View',
            'Mobile Cred View',
            'Internal Admin'
          ]"
        ></app-branch-inputs>
      </div>
    </div>
    <div class="app-engage-nav-bar-container">
      <app-engage-nav-bar
        (sectionChange)="showSection($event)"
      ></app-engage-nav-bar>
    </div>
    <div
      class="inventory-container padding s6 all"
      *ngIf="currentSection === 'inventory'"
    >
      <div class="header">
        <h1>
          {{ "InventoryPage.InventoryTitle" | translate }}
          <span *ngIf="form.controls['myControl'].value.businessId">:</span>
          <span *ngIf="form.controls['myControl'].value.businessId">
            {{ this.form.controls["myControl"].value.businessId }} (Account #{{
              this.form.controls["myControl"].value.accountNumber || "N/A"
            }}) {{ this.form.controls["myControl"].value.addressCity }},
            {{ this.form.controls["myControl"].value.addressState }}</span
          >
        </h1>
      </div>
      <div class="inventory-main-sub-title mat-subheading-2">
        {{ "InventoryPage.CreditReceipts" | translate }}
      </div>
      <div class="columns inventory-section1-inventory">
        <div *ngIf="oneYearCreditHistory">
          <h2 class="inventory-section1-skus--title mat-title">
            {{ "InventoryPage.OneYearLicense" | translate }}:
            {{ oneYearTotal }}
          </h2>
          <ng-container
            *ngIf="oneYearRecentTransactions.length; else noTransfersLast30"
          >
            <ng-container *ngFor="let history of oneYearCreditHistory">
              <div *ngFor="let transaction of history.transactions">
                <div class="inventory-section1-skus">
                  <div class="inventory-section1-cards">
                    <app-inventory-card
                      [received]="transaction.date"
                      [amount]="transaction.amount"
                      [from]="transaction.from"
                      [isNew]="transaction.isNew"
                    ></app-inventory-card>
                  </div>
                </div></div></ng-container
          ></ng-container>
        </div>
        <div *ngIf="fiveYearCreditHistory">
          <h2 class="inventory-section1-skus--title mat-title">
            {{ "InventoryPage.FiveYearLicense" | translate }}:
            {{ fiveYearTotal }}
          </h2>
          <ng-container
            *ngIf="fiveYearRecentTransactions.length; else noTransfersLast30"
          >
            <ng-container *ngFor="let history of fiveYearCreditHistory">
              <div *ngFor="let transaction of history.transactions">
                <div class="inventory-section1-skus">
                  <div class="inventory-section1-cards">
                    <app-inventory-card
                      [received]="transaction.date"
                      [amount]="transaction.amount"
                      [from]="transaction.from"
                      [isNew]="transaction.isNew"
                    ></app-inventory-card>
                  </div>
                </div></div></ng-container
          ></ng-container>
        </div>
        <ng-template #noTransfersLast30>
          <div class="mat-elevation-z4 noReceiptBox">
            {{ "InventoryPage.NoReceipts" | translate }}
          </div>
        </ng-template>
      </div>
    </div>
    <div
      class="inventory-container padding s6 all"
      *ngIf="currentSection === 'transfer'"
    >
      <div class="header">
        <h1 *ifPermissions="['Engage Transfer']">Transfer Licenses</h1>
        <h1 *ifPermissions="['Internal Admin', 'Engage Support']">
          Generate Licenses
        </h1>
      </div>
      <app-credits-transfer-page
        (navigateToInventory)="showSection('inventory')"
        (navigateToHistory)="showSection('history')"
      ></app-credits-transfer-page>
    </div>

    <div
      class="inventory-container-history padding s6 all"
      *ngIf="currentSection === 'history'"
    >
      <div class="header">
        <h1>History</h1>
      </div>
      <app-transfer-history-page></app-transfer-history-page>
    </div>
  </div>
</div>
